(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-article"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // Video functionality
    const videoWrappers = document.querySelectorAll('[data-video-wrapper]');

    videoWrappers.forEach(wrapper => {
      const cover = wrapper.querySelector('[data-video-cover]');
      const container = wrapper.querySelector('[data-video-container]');

      if (cover && container) {
        cover.addEventListener('click', function() {
          cover.style.display = 'none';
          container.classList.remove('hidden');
        });
      }
    });

    // Video overlay functionality
    const overlays = document.querySelectorAll('#videoOverlay');
    const playButtons = document.querySelectorAll('#playButton');

    playButtons.forEach((button, index) => {
      button.addEventListener('click', function() {
        const overlay = overlays[index];
        const iframe = overlay.parentElement.querySelector('iframe');

        // Post message to iframe to play video
        if (iframe.src.includes('youtube')) {
          iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
        } else if (iframe.src.includes('vimeo')) {
          iframe.contentWindow.postMessage('{"method":"play"}', '*');
        }

        // Hide overlay
        overlay.style.opacity = '0';
        overlay.style.pointerEvents = 'none';
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
